import types from '../actionTypes';

export const beginImport = () => ({
    type: types.BEGIN_IMPORT,
});

export const setInProcess = importInProcess => ({
    type: types.SET_IN_PROCESS,
    payload: {
        importInProcess,
    },
});
